export const composeEllipsisAriaLabelText = "XM6qnb";
export const encryptMenuText = "jSnsFb";
export const encryptDisableForwardingMenuText = "emiqU";
export const hideFrom = "Gs4hvc";
export const switchToHTMLMenuItem = "QdkAee";
export default {composeEllipsisAriaLabelText,encryptMenuText,encryptDisableForwardingMenuText,hideFrom,switchToHTMLMenuItem};